// src/components/AccesoDenegado.js
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function AccesoDenegado({ inline = false }) {

  return (
    <Box
      sx={{
        height: inline ? 'auto' : '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: inline ? 'flex-start' : 'center',
        alignItems: 'center',
        textAlign: 'center',
        p: 4,
        border: inline ? '2px dashed #d32f2f' : 'none',
        borderRadius: inline ? 2 : 0,
        backgroundColor: inline ? '#fff0f0' : 'transparent',
        mt: inline ? 2 : 0
      }}
    >
      <Typography variant={inline ? 'h6' : 'h4'} color="error" gutterBottom>
        🚫 Acceso Denegado
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: 600, margin: '0 auto' }}>
        No tienes permisos para acceder a esta sección. Puede que tu perfil haya sido actualizado
        o que tu acceso haya sido restringido por el administrador del sistema.
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        Si crees que esto es un error, por favor contacta al administrador o a soporte técnico.
      </Typography>
    </Box>
  );
}
